// Editors show local time; the API and Calendar links use absolute UTC instants.
export const localEventTime = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return "";
  const pad = (part) => String(part).padStart(2, "0");
  return `${String(date.getFullYear()).padStart(4, "0")}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

export const eventTimestamp = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return null;
  // Reject nonexistent local times (such as the spring daylight-saving gap).
  if (!value.endsWith("Z") && localEventTime(date) !== (value.length === 16 ? `${value}:00` : value)) return null;
  return date.toISOString();
};

export const validEventTimes = ({ eventStart, eventEnd }) => {
  if (!eventStart && !eventEnd) return true;
  const start = eventTimestamp(eventStart);
  const end = eventTimestamp(eventEnd);
  return !!start && !!end && end > start;
};
